import React, { useEffect, useRef, useState } from "react";

import { useDebounce } from "usehooks-ts";

import { TextInput } from "@shared/text-input";

interface Props {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
}

export const SearchInput = ({ value, placeholder, onChange }: Props) => {
  const isInitialRef = useRef(true);
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const debouncedValue = useDebounce(localValue, 500);

  useEffect(() => {
    if (!isInitialRef.current) {
      onChange(debouncedValue);
    }

    isInitialRef.current = false;
  }, [debouncedValue]);

  return (
    <TextInput
      className="shrink-0"
      inputClassName="pl-8"
      width="400px"
      placeholder={placeholder ?? "Search campaign, adset or ad name..."}
      leftIcon={
        <i className="fa-regular fa-sharp fa-search text-gray text-sm" />
      }
      value={localValue}
      onChange={(e) => {
        setLocalValue(e.target.value);
      }}
    />
  );
};
